export { ThemeToggle as default } from "@/lib/theme/ThemeToggle";
